module.exports = __webpack_public_path__ + "img/planes.b6a3b692.png";